/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: PersistentActiveHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler 
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.PersistentActiveHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_GET_PERSISTENT_DOMAIN);
};
$hxClasses['com.inq.flash.client.control.messagehandlers.PersistentActiveHandler'] = com.inq.flash.client.control.messagehandlers.PersistentActiveHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.PersistentActiveHandler.__name__ = ["com","inq","flash","client","control","messagehandlers","PersistentActiveHandler"];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.PersistentActiveHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for(var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.PersistentActiveHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];

/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * override public function processMessage(message:Message):Void
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.PersistentActiveHandler
 * @param {com.inq.flash.messagingframework.Message}  message 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.PersistentActiveHandler.prototype.processMessage = function(message) {
	/** @type {?string} */ 
	var replay = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY);
	if(!com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat()) return;
	if(replay == null || replay != "1") {
		/** @type {?string} */ 
		var xfr = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA);
		if(xfr == null || xfr.length == 0) {
			/** @type {string} */ 
			var protoDomain = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_PROTODOMAIN);
			this.getController().acknowledgeChatPersistent(protoDomain);
		} else {
			/** @type {string} */
			var loc = window.parent.location.href;
			if(loc != xfr) {
				com.inq.flash.client.chatskins.SkinControl.noUnload();
				try {
					window.parent.opener = null;
				} catch( e ) {
					if( js.Boot.__instanceof(e,Error) ) {
						haxe.Log.trace("PersistentActiveHandler.processMessage: " + Std.string(e),{ fileName : "PersistentActiveHandler.hx", lineNumber : 35, className : "com.inq.flash.client.control.messagehandlers.PersistentActiveHandler", methodName : "processMessage"});
					} else throw(e);
				}
				window.parent.location.href = xfr;
			}
		}
	} else haxe.Log.trace("replay",{ fileName : "PersistentActiveHandler.hx", lineNumber : 42, className : "com.inq.flash.client.control.messagehandlers.PersistentActiveHandler", methodName : "processMessage"});
};

/** @type {com.inq.flash.client.control.messagehandlers.PersistentActiveHandler} */
com.inq.flash.client.control.messagehandlers.PersistentActiveHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.PersistentActiveHandler;
